import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { ToastrService } from 'ngx-toastr';
import { Overtime, OvertimeRejectRequest } from 'src/app/_model/overtime';
import { OvertimeRequest } from 'src/app/_model/request/OvertimeRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { LookupService } from 'src/app/_services/lookup.service';
import { OvertimeService } from 'src/app/_services/overtime.service';

@Component({
  selector: 'app-overtime-reject',
  templateUrl: './overtime-reject.component.html',
  styleUrls: ['./overtime-reject.component.sass'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class OvertimeRejectComponent implements OnInit {

  request: OvertimeRejectRequest = new OvertimeRejectRequest();
  currentUser: User;
  selectedRejectReason: any = {};
  rejectReasons: any[];
  rejectDescription = '';

  constructor(public dialogRef: MatDialogRef<OvertimeRejectComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Overtime,
    private authService: AuthenticationService,
    private overtimeService: OvertimeService,
    private toastr: ToastrService,
    private lookupService: LookupService) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.rejectReasons = this.lookupService.localOvertimeRejectReasonLookupList();
  }

  rejectOvertime(overtime: Overtime) {
    this.request.employeeId = this.currentUser.employeeId;
    this.request.operationRecordId = overtime.id;
    this.request.operationTableName = 'overtime';
    this.request.rejectDescription = this.rejectDescription;
    this.request.rejectReasonId = this.selectedRejectReason.id;

    this.overtimeService.rejectOvertime(this.request).subscribe(result => {
      this.toastr.success('reddetme işlemi başarılı', '');
      this.dialogRef.close(true);
    }, error => {
      this.toastr.error(error.error.msg, 'Hata');
      this.dialogRef.close(false);
    });
  }
}
